<script src="poc-page.component.ts"></script>
<div class="wrapper">
  <div class="poc-container">
    <div class="header">
      <div class="mb-1 flex justify-end">
        <span>Tank Operations</span>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.Consumption)"
        >
          + Consumption
        </button>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.Transfer)"
        >
          + Transfer
        </button>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.Bunker)"
        >
          + Bunker
        </button>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.DeBunker)"
        >
          + DeBunker
        </button>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.Correction)"
        >
          + Correction
        </button>
      </div>
      <div class="mb-1 flex justify-end">
        <span>Bridge Operations</span>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.PositionReport)"
        >
          + Position Report
        </button>
        <button
          class="ml-1 rounded-sm bg-blue-500"
          (click)="addAction(reportAction.SpeedAndDistance)"
        >
          + Speed & Distance
        </button>
      </div>
      <div class="flex justify-end">
        <button
          class="ml-1 rounded-sm bg-red-500 px-1"
          (click)="onDeleteAll()"
        >
          Delete All
        </button>

        <button
          class="ml-1 rounded-sm bg-indigo-700 px-1"
          (click)="clickGenerateReport()"
        >
          Generate Report
        </button>
      </div>
    </div>
    <div class="list">
      @for (action of sortedActions; track action.id) {
        <div
          class="section {{ action.reportId ? 'bg-blue-900' : 'bg-blue-950' }}"
        >
          <re-report-operation
            [timestamp]="action.timestamp"
            [reportId]="action.reportId"
          >
            @if (action.type === reportAction.Transfer) {
              <re-tank-transfer
                [action]="action"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.PositionReport) {
              <re-position-report
                [action]="action"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.SpeedAndDistance) {
              <re-speed-and-distance-op
                [action]="action"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.Transfer) {
              <re-tank-transfer
                [action]="action"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.DeBunker) {
              <re-tank-debunker
                [action]="action"
                [from]="action.tanks[0]"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.Correction) {
              <re-tank-correction
                [action]="action"
                [from]="action.tanks[0]"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.Consumption) {
              <re-tank-consumption
                [action]="action"
                [from]="action.tanks[0]"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }

            @if (action.type === reportAction.Bunker) {
              <re-tank-bunker
                [action]="action"
                [from]="action.tanks[0]"
                [tanks]="tanks"
                (reorder)="onReorder($event)"
                (delete)="onDelete($event)"
              />
            }
          </re-report-operation>
        </div>
      }
    </div>
  </div>

  <div class="col grow">
    <div class="tanks mb-8 w-full px-8">
      <div class="header">
        <h2 class="mb-2">Stock Tanks</h2>
      </div>
      <table>
        <thead>
          <tr>
            <th class="px-2">#</th>
            <th class="px-2 text-left">Tank Name</th>
            <th class="px-2 text-left">Fuel Grade</th>
            <th class="px-2 text-right">Quantity</th>
          </tr>
        </thead>
        <tbody>
          @for (tank of updatedTanks; track tank.id) {
            <tr>
              <td class="px-2">{{ tank.number }}</td>
              <td class="px-2">
                {{ tank.name }}
                @if (tank.content?.bdnRef) {
                  <br /><span class="bdn-ref">{{ tank.content?.bdnRef }}</span>
                }
              </td>
              <td class="px-2">{{ tank.content?.fuelGrade }}</td>
              <td class="px-2 text-right">{{ tank.content?.quantity }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="reports w-full px-8">
      <div class="header mb-2 flex">
        <h2 class="grow">Reports</h2>
        <div></div>
      </div>
      <table class="">
        <thead>
          <tr>
            <th class="px-2 text-right">Report No.</th>
            <th class="px-2 text-left">Report Id</th>
            <th class="px-2 text-right">Actions</th>
            <th class="px-2 text-center">Created</th>
          </tr>
        </thead>
        <tbody>
          @for (report of reports; track report.id) {
            <tr
              (click)="clickReportRow(report.id)"
              class="cursor-pointer hover:bg-teal-500
                    {{ isReportSelected(report.id) ? 'bg-teal-600' : '' }}"
            >
              <td class="px-2 text-right">
                {{ $index + 1 }}
              </td>
              <td class="px-2">
                {{ report.id }}
              </td>
              <td class="px-2 text-right">
                {{ getReportActions(report.id) }}
              </td>
              <td class="px-2 text-center">
                {{ report.created | date: 'dd MMM YYYY - hh:mm:ss' }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
